import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/LegalPages.css';

const TermsConditions = () => {
  // Phone number and email
  const phoneNumber = '+918019472678';
  const emailAddress = 'info@hotelsinhyderabad.com';

  return (
    <div className="legal-page-wrapper">
      {/* Hero Banner */}
      <div className="legal-hero-section">
        <div className="legal-hero-overlay">
          <div className="legal-hero-content">
            <span className="legal-hero-badge">✦ Legal</span>
            <h1 className="legal-hero-title">
              Terms &amp; <span className="legal-hero-highlight">Conditions</span>
            </h1>
            <p className="legal-hero-subtitle">
              Please read these terms carefully before using our services.
            </p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="legal-content-section">
        <div className="legal-container">
          <div className="legal-content-wrapper">
            <div className="legal-sidebar">
              <h3>Quick Navigation</h3>
              <ul className="legal-sidebar-list">
                <li><a href="#acceptance">Acceptance of Terms</a></li>
                <li><a href="#booking">Booking &amp; Reservations</a></li>
                <li><a href="#payment">Payment &amp; Cancellation</a></li>
                <li><a href="#check-in">Check-in / Check-out</a></li>
                <li><a href="#liability">Liability &amp; Disclaimer</a></li>
                <li><a href="#conduct">User Conduct</a></li>
                <li><a href="#changes">Changes to Terms</a></li>
                <li><a href="#contact-terms">Contact Us</a></li>
              </ul>
              <div className="legal-sidebar-back">
                <Link to="/" className="legal-back-btn">← Back to Home</Link>
              </div>
            </div>

            <div className="legal-main-content">
              <div className="legal-updated">Last Updated: January 2026</div>

              <section id="acceptance" className="legal-section">
                <h2>1. Acceptance of Terms</h2>
                <p>
                  By accessing and using the AA GRAND HOTEL website and services, you agree to be bound by these Terms and Conditions. 
                  If you do not agree with any part of these terms, please do not use our services.
                </p>
                <p>
                  These terms apply to all visitors, users, and others who access or use our services. 
                  By using our services, you acknowledge that you have read, understood, and agree to be bound by these terms.
                </p>
              </section>

              <section id="booking" className="legal-section">
                <h2>2. Booking &amp; Reservations</h2>
                <p>
                  All bookings made through AA GRAND HOTEL are subject to availability. We reserve the right to refuse or cancel any booking at our discretion.
                </p>
                <ul>
                  <li><strong>Confirmation:</strong> A booking is confirmed only upon receiving a confirmation email from us</li>
                  <li><strong>Accuracy:</strong> You are responsible for providing accurate and complete information during booking</li>
                  <li><strong>Age Requirement:</strong> You must be at least 18 years old to make a booking</li>
                  <li><strong>Couple Friendly:</strong> We are a couple-friendly hotel and welcome all guests with respect</li>
                  <li><strong>Short Stays:</strong> 4-hour stay packages are available subject to availability</li>
                </ul>
              </section>

              <section id="payment" className="legal-section">
                <h2>3. Payment &amp; Cancellation</h2>
                <p>
                  We strive to provide flexible and transparent payment and cancellation policies.
                </p>
                <ul>
                  <li><strong>Payment:</strong> Payment is collected at the time of check-in or as per the booking policy</li>
                  <li><strong>Cancellation:</strong> Cancellation policies vary by booking type and are communicated at the time of booking</li>
                  <li><strong>Refunds:</strong> Refunds are processed as per the cancellation policy</li>
                  <li><strong>No-Show:</strong> Failure to check-in on the scheduled date may result in cancellation without refund</li>
                  <li><strong>Security Deposit:</strong> A security deposit may be required at check-in</li>
                </ul>
                <p className="legal-note">
                  For 4-hour short stay bookings, cancellation is allowed up to 2 hours before the scheduled check-in time.
                </p>
              </section>

              <section id="check-in" className="legal-section">
                <h2>4. Check-in / Check-out</h2>
                <p>
                  Please ensure you adhere to our check-in and check-out timings to avoid any inconvenience.
                </p>
                <ul>
                  <li><strong>Check-in Time:</strong> 12:00 PM (noon)</li>
                  <li><strong>Check-out Time:</strong> 11:00 AM</li>
                  <li><strong>Early Check-in:</strong> Subject to availability and may incur additional charges</li>
                  <li><strong>Late Check-out:</strong> Subject to availability and may incur additional charges</li>
                  <li><strong>Identification:</strong> Valid government-issued ID is required at check-in</li>
                </ul>
              </section>

              <section id="liability" className="legal-section">
                <h2>5. Liability &amp; Disclaimer</h2>
                <p>
                  AA GRAND HOTEL shall not be liable for any loss, damage, or inconvenience arising from:
                </p>
                <ul>
                  <li>Natural disasters, strikes, or other unforeseen circumstances</li>
                  <li>Loss of personal belongings or valuables</li>
                  <li>Medical emergencies or injuries</li>
                  <li>Third-party service disruptions</li>
                  <li>Any indirect or consequential loss</li>
                </ul>
                <p>
                  Guests are advised to secure their valuables and use the in-room safe provided.
                </p>
              </section>

              <section id="conduct" className="legal-section">
                <h2>6. User Conduct</h2>
                <p>
                  Guests are expected to behave responsibly and respectfully during their stay. The following are strictly prohibited:
                </p>
                <ul>
                  <li>Smoking in non-smoking rooms</li>
                  <li>Carrying illegal substances or weapons</li>
                  <li>Creating excessive noise or disturbing other guests</li>
                  <li>Damaging hotel property</li>
                  <li>Unauthorized photography or filming</li>
                </ul>
                <p className="legal-note">
                  Violation of these policies may result in immediate eviction without refund.
                </p>
              </section>

              <section id="changes" className="legal-section">
                <h2>7. Changes to Terms</h2>
                <p>
                  AA GRAND HOTEL reserves the right to modify these Terms and Conditions at any time. 
                  Any changes will be effective immediately upon posting on this page.
                </p>
                <p>
                  We encourage you to review these terms periodically to stay informed about our policies. 
                  Your continued use of our services after any changes constitutes your acceptance of the updated terms.
                </p>
              </section>

              <section id="contact-terms" className="legal-section">
                <h2>8. Contact Us</h2>
                <p>If you have any questions or concerns about these Terms and Conditions, please contact us:</p>
                <div className="legal-contact-info">
                  <p><strong>AA GRAND HOTEL</strong></p>
                  <p>Ameerpet Metro Pillar No. 1072,</p>
                  <p>Above Bata Showroom, First Floor,</p>
                  <p>Hyderabad, Telangana</p>
                  <p>📞 <a href={`tel:${phoneNumber}`}>{phoneNumber}</a></p>
                  <p>📧 <a href={`mailto:${emailAddress}`}>{emailAddress}</a></p>
                </div>
              </section>

              <div className="legal-back-to-top">
                <a href="#top" className="legal-top-btn">↑ Back to Top</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;